import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import {
  Box,
  CircularProgress,
  Container,
  Link,
  Paper,
  Typography,
} from "@mui/material";
import { ErrorMessageType } from "auth/state/types";
import { commonStyle } from "./common";
import { FormComponent } from "./FormComponent";
import LoginSection from "./LoginSection";
import { TermsAndConditionText } from "./TermsAndConditions";
import { useLogin } from "./useLogin";

const AuthContent = ({ signup = false }) => {
  const [
    {
      userEmail,
      userPassword,
      isSignUpActive,
      isPasswordLess,
      isLoading,
      messageType,
      isButtonLoading,
      isFormFieldsActive,
      isResetPasswordSection,
      isPasswordVisible,
      inviteId,
    },
    {
      handleLoginOrSignup,
      toggleSignupHandler,
      handleEmailInput,
      handlePasswordInput,
      togglePasswordLessLogin,
      attemptLoginWithGoogle,
      goBackToLoginSection,
      showFormField,
      showForgotPasswordSection,
      triggerResetPasswordEmail,
      togglePasswordVisibility,
      resendVerificationEmail,
      resendMagicLink,
    },
  ] = useLogin(signup);

  if (isLoading) {
    return (
      <Box sx={commonStyle.loadingContainer}>
        <Typography paddingTop={8} fontSize={20} fontWeight={300}>
          Request is in progress. Please wait...
        </Typography>
        <CircularProgress />
      </Box>
    );
  }

  if (isFormFieldsActive || messageType) {
    return (
      <FormComponent
        userEmail={userEmail}
        userPassword={userPassword}
        isSignUpActive={isSignUpActive}
        isPasswordLess={isPasswordLess}
        handleEmailInput={handleEmailInput}
        handlePasswordInput={handlePasswordInput}
        isButtonLoading={isButtonLoading}
        isResetPasswordSection={isResetPasswordSection}
        handleLoginOrSignup={handleLoginOrSignup}
        togglePasswordLessLogin={togglePasswordLessLogin}
        messageType={messageType}
        goBackToLoginSection={goBackToLoginSection}
        showForgotPasswordSection={showForgotPasswordSection}
        triggerResetPasswordEmail={triggerResetPasswordEmail}
        isPasswordVisible={isPasswordVisible}
        togglePasswordVisibility={togglePasswordVisibility}
        resendVerificationEmail={resendVerificationEmail}
        resendMagicLink={resendMagicLink}
        inviteId={inviteId}
      />
    );
  }
  return (
    <>
      <Box px={2}>
        <Typography
          variant="h3"
          paddingTop={8}
          fontWeight={600}
          color="#494949"
        >
          {isSignUpActive ? "Create an account" : "Welcome back to Orkes Cloud"}
        </Typography>

        <Typography mt={12} mb={4}>
          {isSignUpActive ? "Sign up to continue" : "Sign in to continue"}
        </Typography>
      </Box>
      <LoginSection
        isSignUpActive={isSignUpActive}
        inviteId={inviteId}
        showFormField={showFormField}
        toggleSignupHandler={toggleSignupHandler}
        attemptLoginWithGoogle={attemptLoginWithGoogle}
      />
    </>
  );
};

export const Login = ({ signup = false }: { signup: boolean }) => {
  const [
    { messageType, isFormFieldsActive, isResetPasswordSection },
    { goBackToLoginSection },
  ] = useLogin(signup);

  return (
    <Container>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {(isFormFieldsActive || messageType) && (
          <Link
            sx={{
              ...commonStyle.goBackBtnStyle,
              maxWidth:
                messageType === ErrorMessageType.PERMISSION_DENIED ? 500 : 420,
            }}
            onClick={goBackToLoginSection}
          >
            <ArrowBackOutlinedIcon /> Go Back
          </Link>
        )}
        <Paper
          variant="outlined"
          sx={{
            ...commonStyle.paperStyle,
            minHeight: isResetPasswordSection || messageType ? 350 : 450,
            maxWidth:
              messageType === ErrorMessageType.PERMISSION_DENIED ? 500 : 620,
          }}
        >
          <AuthContent />
        </Paper>
        {!messageType && <TermsAndConditionText />}
      </Box>
    </Container>
  );
};
